import { render, staticRenderFns } from "./complianceResponsiblePersonDrawer.vue?vue&type=template&id=906c7cae&scoped=true"
import script from "./complianceResponsiblePersonDrawer.vue?vue&type=script&lang=js"
export * from "./complianceResponsiblePersonDrawer.vue?vue&type=script&lang=js"
import style0 from "./complianceResponsiblePersonDrawer.vue?vue&type=style&index=0&id=906c7cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906c7cae",
  null
  
)

export default component.exports